import React from 'react';

// UTIL
import { numberFormat } from '../../../utils/Signature/formatCurrency';

// COMPONENT
import { Spreadsheet } from '../Form/svgs';

//STYLES
import {
  ContainerCardProposal,
  HeaderCardProposal,
  Icon,
  TitleCardProposal,
  DescriptionContent,
  DescriptionValueProposal,
  TextValueProposal,
  ValueProposal,
  HeaderProposal,
} from './styles';

export const ProposalConsigRetention = ({ formValues }: any) => {
  return (
    <ContainerCardProposal className="accordion__section">
      <HeaderCardProposal>
        <HeaderProposal>
          <Icon>
            <Spreadsheet />
          </Icon>
          <TitleCardProposal>Proposta {formValues.proposalNumber}</TitleCardProposal>
        </HeaderProposal>
      </HeaderCardProposal>
      <DescriptionContent>
        <DescriptionValueProposal>
          <TextValueProposal>Identificador único da portabilidade</TextValueProposal>
          <ValueProposal>{formValues.idNuPortability}</ValueProposal>
        </DescriptionValueProposal>
        <DescriptionValueProposal>
          <TextValueProposal>Valor da parcela</TextValueProposal>
          <ValueProposal>{numberFormat(formValues.installmentValue)}</ValueProposal>
        </DescriptionValueProposal>
      </DescriptionContent>
    </ContainerCardProposal>
  );
};
